
import axios from 'axios';
import Vue from 'vue';
import {Asset} from '../../types/models';
import VueButton from '../forms/button.vue';
import VueCheckbox from '../forms/checkbox.vue';
import VueError from '../forms/error.vue';
import VueFormGroup from '../forms/form-group.vue';
import VueSelect from '../forms/select.vue';
import VueText from '../forms/text.vue';
import VueThumbnail from "../thumbnail.vue";
import VueRichEditor from "./rich-editor.vue";

export default {
  name: 'VueApplicationForm',
  components: {
    'vue-form-group': VueFormGroup,
    'vue-text': VueText,
    'vue-select': VueSelect,
    'vue-checkbox': VueCheckbox,
    'vue-button': VueButton,
    'vue-error': VueError,
    'vue-rich-editor': VueRichEditor,
    'vue-thumbnail': VueThumbnail,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
    job: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    applicationSync: {
      get() {
        return this.application;
      },
      set(value) {
        this.$emit('update:application', value);
      },
    },
    dismissalPeriod() {
      return [
        'Brak',
        '3 dni robocze',
        '1 tydzień',
        '2 tygodnie',
        '1 miesiąc',
        '3 miesiące',
      ].reduce((acc, value) => {
        acc[value] = value;
        return acc;
      }, {});
    },
    salaryChoices() {
      return [
        'od 1000 zł m-c',
        'od 2000 zł m-c',
        'od 3000 zł m-c',
        'od 4000 zł m-c',
        'od 5000 zł m-c',
        'od 6000 zł m-c',
        'od 7000 zł m-c',
        'od 8000 zł m-c',
        'od 9000 zł m-c',
        'od 10000 zł m-c',
      ].reduce((acc, value) => {
        acc[value] = value;
        return acc;
      }, {});
    },
  },
  methods: {
    submitForm() {
      this.isProcessing = true;

      axios.post<any>(`/Praca/Application/${this.job.id}`, this.applicationSync)
        .then(result => window.location.href = result.data as string)
        .catch(err => {
          if (err.response.status !== 422) {
            return;
          }

          this.errors = err.response.data.errors;
        })
        .finally(() => this.isProcessing = false);
    },
    addAsset(asset: Asset) {
      this.applicationSync.cv = asset.filename;
    },
    deleteAsset() {
      this.applicationSync.cv = null;
    },
  },
};
